exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.relate-protocol {\n  background-color: #fafafa;\n}\n.relate-protocol .header .description {\n  color: #666666;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-size: 0.346667rem;\n  line-height: 1.333333rem;\n  padding-left: 0.4rem;\n  font-weight: 400;\n}\n.relate-protocol .navigate-list {\n  padding-top: 0.266667rem;\n}\n.relate-protocol .navigate-list .navigate-item {\n  height: 1.466667rem;\n  line-height: 1.466667rem;\n  margin-top: 0;\n  padding-left: 0.2rem;\n  padding-right: 0.226667rem;\n  border-bottom: 0.013333rem solid #EEEEEE;\n}", ""]);

// exports
